import type { ChannelProviderName } from '../../../pages/admin/channels-types.js'

export interface ManualField {
  key: string
  label: string
  type?: 'text' | 'password'
}

/** Per-provider manual-credential field sets. Providers without an entry here
 * fall back to a generic single "API Key" field. Shared by AddAccountModal
 * (create) and EditAccountModal (update manual accounts). */
export const MANUAL_FIELDS: Partial<Record<ChannelProviderName, ManualField[]>> = {
  whatsapp: [
    { key: 'businessAccountId', label: 'WhatsApp Business Account ID' },
    { key: 'phoneNumberId', label: 'Phone Number ID' },
    { key: 'accessToken', label: 'Access Token', type: 'password' },
    { key: 'appSecret', label: 'Webhook App Secret', type: 'password' },
  ],
  facebook: [
    { key: 'pageId', label: 'Page ID' },
    { key: 'accessToken', label: 'Page Access Token', type: 'password' },
    { key: 'appSecret', label: 'Webhook App Secret', type: 'password' },
  ],
  instagram: [
    { key: 'igUserId', label: 'Instagram User ID' },
    { key: 'accessToken', label: 'Access Token', type: 'password' },
    { key: 'appSecret', label: 'Webhook App Secret', type: 'password' },
  ],
  youtube: [
    { key: 'channelId', label: 'Channel ID' },
    { key: 'apiKey', label: 'API Key', type: 'password' },
  ],
  x: [
    { key: 'apiKey', label: 'API Key', type: 'password' },
    { key: 'apiSecret', label: 'API Secret', type: 'password' },
  ],
}

export const CHANNEL_FOR_PROVIDER: Record<ChannelProviderName, string> = {
  facebook: 'facebook',
  instagram: 'instagram',
  whatsapp: 'whatsapp',
  youtube: 'youtube',
  x: 'x',
}
